<div>
  <p>{{'imprint_1' | translate}}</p> 
  <p>{{'imprint_2' | translate}}</p> 
  <p>{{'imprint_3' | translate}}</p> 
  <p>{{'imprint_4' | translate}}</p> 
</div>
